import Lock from '@repo/ui/lock'
import { useMutation } from '@tanstack/react-query'
import React, { useState } from 'react'

import { lockTripBooking, unlockTripBooking } from '../../../api/trip-bookings/update-trip-booking'

type Props = {
  tripBookingId: number
  tripBookingLocked: boolean
}

const TripBookingLock: React.FC<Props> = ({ tripBookingId, tripBookingLocked }) => {
  const [locked, setLocked] = useState(tripBookingLocked)

  const { mutate: lockTripBookingMutation } = useMutation({
    mutationFn: lockTripBooking,
    onError: () => {
      setLocked(false)
    }
  })

  const { mutate: unlockTripBookingMutation } = useMutation({
    mutationFn: unlockTripBooking,
    onError: () => {
      setLocked(true)
    }
  })

  return (
    <Lock
      isLocked={locked}
      onClick={(e) => {
        e.stopPropagation()
        const newStatus = !locked
        setLocked(newStatus)
        if (newStatus) lockTripBookingMutation(tripBookingId)
        else unlockTripBookingMutation(tripBookingId)
      }}
    />
  )
}

export default TripBookingLock
